<pf-modal
    #restoredModal
    name="restored"
    [title]="('dialog.restored.title' | i18next)"
    [body]="('dialog.restored.text' | i18next)"
    confirmButtonText="Ok"
    modalId='modal-nachricht-wiederhergestellt'
    (confirmed)="handleAction(nachrichtAction.RESTORE,currentNachricht, true)"
/>

<pf-modal
    #restoredErrorModal
    name="restoredError"
    [title]="('dialog.restore-error.title' | i18next)"
    [body]="('dialog.restore-error.text' | i18next)"
    confirmButtonText="Ok"
    modalId='modal-wiederherstellen-nicht-moeglich'
/>

<pf-modal
    #deletedModal
    name="deleted"
    [title]="('dialog.deleted.title' | i18next)"
    [body]="('dialog.deleted.text' | i18next)"
    modalId='modal-nachricht-geloescht'
    (confirmed)="handleAction(nachrichtAction.DELETE,currentNachricht, true)"
/>

<pf-modal
    #deleteErrorModal
    name="deleteError"
    [title]="('dialog.deleted.title' | i18next)"
    [body]="('dialog.deleted.text' | i18next)"
    modalId='modal-loeschen-nicht-moeglich'
/>

<pf-modal
    #deleteIrrevocableConfirmModal
    name="deleteIrrevocableConfirm"
    [title]="('dialog.delete-irrevocable-confirm.title' | i18next)"
    [body]="('dialog.delete-irrevocable-confirm.text' | i18next:{betreff:currentNachricht?.betreff})"
    [cancelButtonText]="'dialog.delete-irrevocable-confirm.cancel' | i18next"
    modalId='modal-unwiderruflich-loeschen'
    (confirmed)="handleAction(nachrichtAction.DELETE_IRREVOCABLE,currentNachricht, true)"
/>

<pf-modal
    #deletedIrrevocableModal
    name="deletedIrrevocable"
    [title]="('dialog.deleted-irrevocable.title' | i18next)"
    [body]="('dialog.deleted-irrevocable.text' | i18next:{betreff:currentNachricht?.betreff} )"
    modalId='modal-nachricht-unwiderruflich-geloescht'
    (cancelled)="emitPendingReload()"
    (confirmed)="emitPendingReload()"
/>
